module.exports = __webpack_public_path__ + "static/undergroundcella-logo-0f42a673e877cc72f6ebc2a0874ee9a1.png";